'use client';

import { useEffect, useState } from 'react';

import {
  applyLegacyCookieConsentFromDocument,
  useCookieConsentStore,
} from '@/stores/cookie-consent-store';

/** Rehydrate persisted consent and sync legacy `cookieConsent` document cookie. */
export function useCookieConsentHydration(): boolean {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const unsubFinish = useCookieConsentStore.persist.onFinishHydration(() => {
      applyLegacyCookieConsentFromDocument();
      setHydrated(true);
    });
    void useCookieConsentStore.persist.rehydrate();
    return unsubFinish;
  }, []);

  return hydrated;
}
